/* eslint-disable jsx-a11y/media-has-caption */

import React from "react";

import { Icon, PlainButton, Thumbnail } from "@culturehq/components";

import instagram from "images/social/instagram.svg";

import Subtitles from "components/common/Subtitles";
import getUserName from "app/utils/getUserName";

const InstagramPreview = ({
  mediaRef,
  showVideoInfo,
  onShowVideoInfo,
  onPlay,
  imageUrl,
  data,
  profile,
  shareMessage,
  story
}) => (
  <>
    <div className="Body_Header Preview-User">
      <div className="Preview-User__Info-Container">
        <Thumbnail className="Thumbnail" image={data?.author?.profilePictureUrl || profile.avatar.thumbUrl} title={data?.author?.name || getUserName(profile)} />
        <div>
          <p className="Preview-User__Info Preview-User__Info-Name">{data?.author?.name || getUserName(profile)}</p>
        </div>
      </div>
      <img className="social-icon" src={instagram} alt="Instagram" />
    </div>
    <div className="gallery-lightbox__photo">
      <div className="gallery-lightbox__image-container" style={{ backgroundImage: `url(${imageUrl})` }} />
      {story.media.mediaType === "image" && (
        <img
          className="gallery-lightbox__photo--image"
          ref={mediaRef}
          src={imageUrl}
          alt={story.imageAlt || story.question.question}
        />
      )}
      {story.media.mediaType === "video" && (
        <>
          {showVideoInfo && (
            <div className="gallery-lightbox__video-play" onClick={onPlay}><Icon icon="play-filled" /></div>
          )}
          <video
            controls
            className="gallery-lightbox__main-image gallery-lightbox__main-video"
            onPause={() => onShowVideoInfo(true)}
            onPlay={() => onShowVideoInfo(false)}
            poster={`${story.media.thumbnail}?not-from-cache-please`}
            ref={mediaRef}
            src={story.media.url}
            disablePictureInPicture
            crossOrigin="anonymous"
            controlsList="nodownload"
          >
            <Subtitles media={story.media} />
          </video>
        </>
      )}
    </div>
    <div className="Preview-Actions Instagram-Buttons">
      <PlainButton className="like-btn">
        <svg color="#8e8e8e" height="24" role="img" viewBox="0 0 24 24" width="24">
          <path fill="#8e8e8e" d="M16.792 3.904A4.989 4.989 0 0 1 21.5 9.122c0 3.072-2.652 4.959-5.197 7.222-2.512 2.243-3.865 3.469-4.303 3.752-.477-.309-2.143-1.823-4.303-3.752C5.141 14.072 2.5 12.167 2.5 9.122a4.989 4.989 0 0 1 4.708-5.218 4.21 4.21 0 0 1 3.675 1.941c.84 1.175.98 1.763 1.12 1.763s.278-.588 1.11-1.766a4.17 4.17 0 0 1 3.679-1.938m0-2a6.04 6.04 0 0 0-4.797 2.127 6.052 6.052 0 0 0-4.787-2.127A6.985 6.985 0 0 0 .5 9.122c0 3.61 2.55 5.827 5.015 7.97.283.246.569.494.853.747l1.027.918a44.998 44.998 0 0 0 3.518 3.018 2 2 0 0 0 2.174 0 45.263 45.263 0 0 0 3.626-3.115l.922-.824c.293-.26.59-.519.885-.774 2.334-2.025 4.98-4.32 4.98-7.94a6.985 6.985 0 0 0-6.708-7.218Z" />
        </svg>
      </PlainButton>
      <PlainButton>
        <svg color="#262626" fill="#262626" height="24" role="img" viewBox="0 0 24 24" width="24">
          <path d="M20.656 17.008a9.993 9.993 0 1 0-3.59 3.615L22 22Z" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="2" />
        </svg>
      </PlainButton>
      <PlainButton>
        <svg color="#262626" fill="#262626" height="24" role="img" viewBox="0 0 24 24" width="24">
          <line fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="2" x1="22" x2="9.218" y1="3" y2="10.083" />
          <polygon fill="none" points="11.698 20.334 22 3.001 2 3.001 9.218 10.084 11.698 20.334" stroke="currentColor" strokeLinejoin="round" strokeWidth="2" />
        </svg>
      </PlainButton>
    </div>
    <div className="Preview-area no-scrollbar">
      <span className="Preview-User__Info Preview-User__Info-Name">{data?.author?.name || getUserName(profile)}</span>
      <span>{data?.text || shareMessage}</span>
    </div>
  </>
);

export default InstagramPreview;
